import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertTemplateComponent } from '../../alert/alert-template.component';

@Injectable()
export class MessagesService {

    private dialogRef: MatDialogRef<AlertTemplateComponent>;

    constructor(public dialog: MatDialog) {
    }


    openAlertDialog(messageSent: string, titulo: string, aceptButton = 'Aceptar', cancelButton = 'Cerrar', clase = 'my-custom-dialog-class',
        showBAccept = true, showBCancel = false): void {
        const dialogRef = this.dialog.open(AlertTemplateComponent, {
            panelClass: clase,
            data: {
                title: titulo,
                message: messageSent,
                showButtonAccept: showBAccept,
                showButtonCancel: showBCancel,
                labelButtonCancel: cancelButton,
                labelButtonSave: aceptButton,
                loading: false,
                buttonText: {
                    cancel: cancelButton
                }
            },
        });
    }

    showFormInDialog(formToBuilt: any, titulo: string, boldTitleParam: string, functionToExecute: any, clase = 'my-custom-dialog-class',
        responseMessageSend = 'Guardado Correctamente', ...paramsSend): MatDialogRef<any> {
        const dialogRef = this.dialog.open(AlertTemplateComponent, {
            panelClass: clase,
            data: {
                responseMessage: responseMessageSend,
                title: titulo,
                boldTitle: boldTitleParam,
                params: paramsSend,
                functionToSave: functionToExecute,
                form: formToBuilt,
                showButtonAccept: true,
                loading: false,
                buttonText: {
                    cancel: 'Aceptar'
                }
            },
        });

        return dialogRef;
    }

    showFormInDialogButtons(formToBuilt: any, titulo: string, boldTitleParam: string, functionToExecute: any,
                            buttonSave: string, buttonCancel: string, showBAccept = true, showCancel = true, clase = 'my-custom-dialog-class',
                            responseMessageSend = 'Guardado Correctamente', showPromotion = false, ...paramsSend): MatDialogRef<any> {
        const dialogRef = this.dialog.open(AlertTemplateComponent, {
            panelClass: clase,
            hasBackdrop: true,
            data: {
                responseMessage: responseMessageSend,
                title: titulo,
                boldTitle: boldTitleParam,
                isContentCentered: true,
                params: paramsSend,
                functionToSave: functionToExecute,
                form: formToBuilt,
                showButtonAccept: showBAccept,
                showButtonCancel: showCancel,
                labelButtonSave: buttonSave,
                labelButtonCancel: buttonCancel,
                showPromotionText: showPromotion,
                loading: false,
                buttonText: {
                    cancel: 'Aceptar'
                }
            },
        });

        return dialogRef;
    }

    showDocumentToSign(document: HTMLElement, titulo: string, fields: string[], clase = 'my-custom-dialog-class',
                       imageSignSent?: any): MatDialogRef<any> {
        const dialogRef = this.dialog.open(AlertTemplateComponent, {
            panelClass: clase,
            data: {
                html: document,
                isPdfDocument: true,
                title: titulo,
                showButtonAccept: true,
                loading: false,
                fieldsToCheck: fields,
                imageSign: imageSignSent,
                buttonText: {
                    cancel: 'Aceptar'
                }
            },
        });

        return dialogRef;
    }

    startLoading(): void {
        this.dialogRef = this.dialog.open(AlertTemplateComponent, {
            data: {
                loading: true,
                showButtonAccept: false
            },
        });
    }

    closeWindow(): void {
        if (this.dialogRef) {
            this.dialogRef.close(true);
        }
    }

}
